import TutorialPost from './tutorialPost'

export default TutorialPost
